export const abort = Symbol('abort');
export const activeElement = Symbol('activeElement');
export const asyncTaskManager = Symbol('asyncTaskManager');
export const bodyBuffer = Symbol('bodyBuffer');
export const buffer = Symbol('buffer');
export const cachedResponse = Symbol('cachedResponse');
export const callbacks = Symbol('callbacks');
export const checked = Symbol('checked');
export const childNodes = Symbol('childNodes');
export const children = Symbol('children');
export const classList = Symbol('classList');
export const connectedToNode = Symbol('connectedToNode');
export const disconnectedFromNode = Symbol('disconnectedFromNode');
export const connectedToDocument = Symbol('connectedToDocument');
export const disconnectedFromDocument = Symbol('disconnectedFromDocument');
export const contentLength = Symbol('contentLength');
export const contentType = Symbol('contentType');
export const cssText = Symbol('cssText');
export const currentScript = Symbol('currentScript');
export const currentTarget = Symbol('currentTarget');
export const data = Symbol('data');
export const defaultView = Symbol('defaultView');
export const destroy = Symbol('destroy');
export const dirtyness = Symbol('dirtyness');
export const end = Symbol('end');
export const entries = Symbol('entries');
export const evaluateCSS = Symbol('evaluateCSS');
export const evaluateScript = Symbol('evaluateScript');
export const exceptionObserver = Symbol('exceptionObserver');
export const formNode = Symbol('formNode');
export const internalId = Symbol('internalId');
export const height = Symbol('height');
export const immediatePropagationStopped = Symbol('immediatePropagationStopped');
export const indeterminate = Symbol('indeterminate');
export const isFirstWrite = Symbol('isFirstWrite');
export const isFirstWriteAfterOpen = Symbol('isFirstWriteAfterOpen');
export const isInPassiveEventListener = Symbol('isInPassiveEventListener');
export const isValue = Symbol('isValue');
export const listenerOptions = Symbol('listenerOptions');
export const listeners = Symbol('listeners');
export const namedItems = Symbol('namedItems');
export const nextActiveElement = Symbol('nextActiveElement');
export const observeMutations = Symbol('observeMutations');
export const observedAttributes = Symbol('observedAttributes');
export const mutationListeners = Symbol('mutationListeners');
export const ownerDocument = Symbol('ownerDocument');
export const ownerElement = Symbol('ownerElement');
export const propagationStopped = Symbol('propagationStopped');
export const readyStateManager = Symbol('readyStateManager');
export const referrer = Symbol('referrer');
export const registry = Symbol('registry');
export const relList = Symbol('relList');
export const resetSelection = Symbol('resetSelection');
export const rootNode = Symbol('rootNode');
export const selectNode = Symbol('selectNode');
export const selectedness = Symbol('selectedness');
export const selection = Symbol('selection');
export const setupVMContext = Symbol('setupVMContext');
export const shadowRoot = Symbol('shadowRoot');
export const start = Symbol('start');
export const style = Symbol('style');
export const target = Symbol('target');
export const textAreaNode = Symbol('textAreaNode');
export const unobserveMutations = Symbol('unobserveMutations');
export const reportMutation = Symbol('reportMutation');
export const updateSelectedness = Symbol('updateSelectedness');
export const url = Symbol('url');
export const value = Symbol('value');
export const width = Symbol('width');
export const window = Symbol('window');
export const windowResizeListener = Symbol('windowResizeListener');
export const mutationObservers = Symbol('mutationObservers');
export const openerFrame = Symbol('openerFrame');
export const openerWindow = Symbol('openerWindow');
export const popup = Symbol('popup');
export const isConnected = Symbol('isConnected');
export const parentNode = Symbol('parentNode');
export const nodeType = Symbol('nodeType');
export const tagName = Symbol('tagName');
export const prefix = Symbol('prefix');
export const scrollHeight = Symbol('scrollHeight');
export const scrollWidth = Symbol('scrollWidth');
export const scrollTop = Symbol('scrollTop');
export const scrollLeft = Symbol('scrollLeft');
export const attributes = Symbol('attributes');
export const attributesProxy = Symbol('attributesProxy');
export const namespaceURI = Symbol('namespaceURI');
export const accessKey = Symbol('accessKey');
export const accessKeyLabel = Symbol('accessKeyLabel');
export const contentEditable = Symbol('contentEditable');
export const isContentEditable = Symbol('isContentEditable');
export const offsetHeight = Symbol('offsetHeight');
export const offsetWidth = Symbol('offsetWidth');
export const offsetLeft = Symbol('offsetLeft');
export const offsetTop = Symbol('offsetTop');
export const clientHeight = Symbol('clientHeight');
export const clientWidth = Symbol('clientWidth');
export const clientLeft = Symbol('clientLeft');
export const clientTop = Symbol('clientTop');
export const name = Symbol('name');
export const specified = Symbol('specified');
export const adoptedStyleSheets = Symbol('adoptedStyleSheets');
export const implementation = Symbol('implementation');
export const readyState = Symbol('readyState');
export const publicId = Symbol('publicId');
export const systemId = Symbol('systemId');
export const validationMessage = Symbol('validationMessage');
export const validity = Symbol('validity');
export const returnValue = Symbol('returnValue');
export const elements = Symbol('elements');
export const length = Symbol('length');
export const complete = Symbol('complete');
export const naturalHeight = Symbol('naturalHeight');
export const naturalWidth = Symbol('naturalWidth');
export const loading = Symbol('loading');
export const x = Symbol('x');
export const y = Symbol('y');
export const defaultChecked = Symbol('defaultChecked');
export const files = Symbol('files');
export const sheet = Symbol('sheet');
export const volume = Symbol('volume');
export const paused = Symbol('paused');
export const currentTime = Symbol('currentTime');
export const playbackRate = Symbol('playbackRate');
export const defaultPlaybackRate = Symbol('defaultPlaybackRate');
export const muted = Symbol('muted');
export const defaultMuted = Symbol('defaultMuted');
export const preservesPitch = Symbol('preservesPitch');
export const buffered = Symbol('buffered');
export const duration = Symbol('duration');
export const error = Symbol('error');
export const ended = Symbol('ended');
export const networkState = Symbol('networkState');
export const textTracks = Symbol('textTracks');
export const seeking = Symbol('seeking');
export const seekable = Symbol('seekable');
export const played = Symbol('played');
export const options = Symbol('options');
export const content = Symbol('content');
export const mode = Symbol('mode');
export const host = Symbol('host');
export const setURL = Symbol('setURL');
export const localName = Symbol('localName');
export const registedClass = Symbol('registedClass');
export const nodeStream = Symbol('nodeStream');
export const location = Symbol('location');
export const history = Symbol('history');
export const navigator = Symbol('navigator');
export const screen = Symbol('screen');
export const sessionStorage = Symbol('sessionStorage');
export const localStorage = Symbol('localStorage');
export const sandbox = Symbol('sandbox');
export const cloneNode = Symbol('cloneNode');
export const appendChild = Symbol('appendChild');
export const removeChild = Symbol('removeChild');
export const insertBefore = Symbol('insertBefore');
export const replaceChild = Symbol('replaceChild');
export const tracks = Symbol('tracks');
export const constraints = Symbol('constraints');
export const capabilities = Symbol('capabilities');
export const settings = Symbol('settings');
export const clone = Symbol('clone');
export const removeNamedItem = Symbol('removeNamedItem');
export const items = Symbol('items');
export const selectedOptions = Symbol('selectedOptions');
export const styleNode = Symbol('styleNode');
export const updateSheet = Symbol('updateSheet');
export const clearCache = Symbol('clearCache');
export const onSetAttribute = Symbol('onSetAttribute');
export const onRemoveAttribute = Symbol('onRemoveAttribute');
export const nodeArray = Symbol('nodeArray');
export const elementArray = Symbol('elementArray');
export const cache = Symbol('cache');
export const affectsCache = Symbol('affectsCache');
export const forms = Symbol('forms');
export const affectsComputedStyleCache = Symbol('affectsComputedStyleCache');
export const query = Symbol('query');
export const computedStyle = Symbol('computedStyle');
export const getFormControlItems = Symbol('getFormControlItems');
export const getFormControlNamedItem = Symbol('getFormControlNamedItem');
export const dataset = Symbol('dataset');
export const getNamespaceItemKey = Symbol('getNamespaceItemKey');
export const getNamedItemKey = Symbol('getNamedItemKey');
export const namespaceItems = Symbol('namespaceItems');
export const proxy = Symbol('proxy');
export const setNamedItem = Symbol('setNamedItem');
export const getTokenList = Symbol('getTokenList');
export const attributeName = Symbol('attributeName');
export const selectedIndex = Symbol('selectedIndex');
export const self = Symbol('self');
export const parent = Symbol('parent');
export const top = Symbol('top');
export const areas = Symbol('areas');
export const defaultValue = Symbol('defaultValue');
export const elementIdMap = Symbol('elementIdMap');
export const clonable = Symbol('clonable');
export const delegatesFocus = Symbol('delegatesFocus');
export const serializable = Symbol('serializable');
export const slotAssignment = Symbol('slotAssignment');
export const assignedNodes = Symbol('assignedNodes');
export const assignedToSlot = Symbol('assignedToSlot');
export const cells = Symbol('cells');
export const rows = Symbol('rows');
export const headers = Symbol('headers');
export const tBodies = Symbol('tBodies');
export const track = Symbol('track');
export const controlsList = Symbol('controlsList');
export const mediaKeys = Symbol('mediaKeys');
export const remote = Symbol('remote');
export const sinkId = Symbol('sinkId');
export const srcObject = Symbol('srcObject');
export const cues = Symbol('cues');
export const activeCues = Symbol('activeCues');
export const kind = Symbol('kind');
export const label = Symbol('label');
export const language = Symbol('language');
export const id = Symbol('id');
export const illegalConstructor = Symbol('illegalConstructor');
export const state = Symbol('state');
export const canvas = Symbol('canvas');
export const popoverTargetElement = Symbol('popoverTargetElement');
export const composed = Symbol('composed');
export const bubbles = Symbol('bubbles');
export const cancelable = Symbol('cancelable');
export const defaultPrevented = Symbol('defaultPrevented');
export const eventPhase = Symbol('eventPhase');
export const timeStamp = Symbol('timeStamp');
export const type = Symbol('type');
export const detail = Symbol('detail');
export const globalObject = Symbol('globalObject');
export const destroyed = Symbol('destroyed');
export const aborted = Symbol('aborted');
export const browserFrames = Symbol('browserFrames');
export const windowInternalId = Symbol('windowInternalId');
